import Lenis from "lenis";

let lenis = null;

export const startLenis = () => {
  lenis = new Lenis({ duration: 1.25, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
  let id;
  const raf = (time) => {
    lenis.raf(time);
    id = requestAnimationFrame(raf);
  };
  id = requestAnimationFrame(raf);
  return () => {
    cancelAnimationFrame(id);
    lenis.destroy();
    lenis = null;
  };
};

export const scrollToTarget = (target, opts = {}) => {
  const el = typeof target === "string" ? document.querySelector(target) : target;
  if (target !== 0 && !el) return;
  if (lenis) lenis.scrollTo(target === 0 ? 0 : el, { offset: -70, ...opts });
  else if (target === 0) window.scrollTo(0, 0);
  else el.scrollIntoView({ behavior: "smooth" });
};

export const setScrollLock = (locked) => {
  if (!lenis) return;
  if (locked) lenis.stop();
  else lenis.start();
};
